import React from 'react'
//import { HiOutlineMenuAlt2, HiOutlineMenu } from 'react-icons/hi'
import { RiMenuFold2Fill, RiMenuFoldFill  } from "react-icons/ri";
import { Tooltip } from 'components/ui'

const NavToggle = ({ toggled, className }) => {
    return (
        <div className={className}>
            <Tooltip title={toggled ? "펼치기" : "접기"} placement="right">
                {toggled ? <RiMenuFoldFill  /> : <RiMenuFold2Fill />}
            </Tooltip>
        </div>
    )
}

export default NavToggle
